var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import clsx from 'clsx';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { useClasses, useProps, useTranslate } from '@hawkins/helpers';
import { IconCalendar } from '@hawkins/icons/lib/iconCalendar';
import { IconChevronDown } from '@hawkins/icons/lib/iconChevronDown';
import { IconChevronUp } from '@hawkins/icons/lib/iconChevronUp';
import { IconClose } from '@hawkins/icons/lib/iconClose';
import { Button } from '../button';
import { FloatingUI } from '../floatingUi';
import { useId } from '../hooks';
import { Input } from '../input';
import { DatePicker } from './datePicker';
import { DatePickerStrings } from './datePicker.strings';
import { useDatePickerInputStyles } from './datePickerInput.styles';
import { dayjs } from './dayjs';
export var DATEPICKER_DEFAULT_FORMAT = 'MM/DD/YYYY';
export var DATETIMEPICKER_DEFAULT_FORMAT = 'MM/DD/YYYY HH:mm';
export var DATETIMEPICKER_DEFAULT_FORMAT_12HOUR = 'MM/DD/YYYY hh:mm A';
export var DATETIMEPICKER_DEFAULT_FORMAT_WITH_SECONDS = 'MM/DD/YYYY HH:mm:ss';
export var DATETIMEPICKER_DEFAULT_FORMAT_WITH_SECONDS_12HOUR = 'MM/DD/YYYY hh:mm:ss A';
dayjs.extend(CustomParseFormat);
var displayName = 'DatePickerInputImpl';
export var DatePickerInputImpl = React.forwardRef(function (_a, ref) {
    var _ = _a.children, props = __rest(_a, ["children"]);
    // props
    var _b = useProps(displayName, props), classesProp = _b.classes, _c = _b.clearable, clearable = _c === void 0 ? false : _c, _d = _b.closeDropdownOnSelectedChange, closeDropdownOnSelectedChange = _d === void 0 ? false : _d, datePickerId = _b.datePickerId, description = _b.description, disabled = _b.disabled, floatingUiProps = _b.floatingUiProps, formatProp = _b.format, _e = _b.hideEndAdornment, hideEndAdornment = _e === void 0 ? false : _e, _f = _b.hideStartAdornment, hideStartAdornment = _f === void 0 ? false : _f, id = _b.id, inputProps = _b.inputProps, label = _b.label, _g = _b.mask, mask = _g === void 0 ? true : _g, onBlur = _b.onBlur, onCurrentDateChange = _b.onCurrentDateChange, onFocus = _b.onFocus, onGoToNextMonth = _b.onGoToNextMonth, onGoToPreviousMonth = _b.onGoToPreviousMonth, openProp = _b.open, onSelectedChange = _b.onSelectedChange, pickerVariant = _b.pickerVariant, _h = _b.placement, placement = _h === void 0 ? 'bottom-start' : _h, _j = _b.range, range = _j === void 0 ? false : _j, selected = _b.selected, _k = _b.tabIndex, tabIndex = _k === void 0 ? -1 : _k, timePickerProps = _b.timePickerProps, translateProp = _b.translate, _l = _b.variant, variant = _l === void 0 ? 'input' : _l, rest = __rest(_b, ["classes", "clearable", "closeDropdownOnSelectedChange", "datePickerId", "description", "disabled", "floatingUiProps", "format", "hideEndAdornment", "hideStartAdornment", "id", "inputProps", "label", "mask", "onBlur", "onCurrentDateChange", "onFocus", "onGoToNextMonth", "onGoToPreviousMonth", "open", "onSelectedChange", "pickerVariant", "placement", "range", "selected", "tabIndex", "timePickerProps", "translate", "variant"]);
    var format = formatProp !== null && formatProp !== void 0 ? formatProp : DATEPICKER_DEFAULT_FORMAT;
    if (pickerVariant === 'datetimepicker') {
        if (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.use12HourClock) {
            if (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.withSeconds)
                format = DATETIMEPICKER_DEFAULT_FORMAT_WITH_SECONDS_12HOUR;
            else
                format = DATETIMEPICKER_DEFAULT_FORMAT_12HOUR;
        }
        else if (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.withSeconds)
            format = DATETIMEPICKER_DEFAULT_FORMAT_WITH_SECONDS;
        else
            format = DATETIMEPICKER_DEFAULT_FORMAT;
    }
    // strings
    var translate = useTranslate(translateProp, DatePickerStrings);
    // styles
    var baseClasses = useDatePickerInputStyles();
    var _m = useClasses(displayName, baseClasses, classesProp), dropdownClassName = _m.dropdown, dropdownEndAdornmentClassName = _m.dropdownEndAdornment, dropdownStartAdornmentClassName = _m.dropdownStartAdornment, restClasses = __rest(_m, ["dropdown", "dropdownEndAdornment", "dropdownStartAdornment"]);
    var _o = __read(React.useState(null), 2), inputContainerRef = _o[0], setInputContainerRef = _o[1];
    var _p = __read(React.useState(null), 2), datepickerRef = _p[0], setDatepickerRef = _p[1];
    // state
    var _q = __read(React.useState(''), 2), internalInputVal = _q[0], setInternalInputVal = _q[1];
    var _r = __read(React.useState(false), 2), openInternal = _r[0], setOpenInternal = _r[1];
    var _s = __read(React.useState(), 2), selectedInternal = _s[0], setSelectedInternal = _s[1];
    var selectedVal = selected !== null && selected !== void 0 ? selected : selectedInternal;
    // local variables
    var open = 'open' in props ? openProp !== null && openProp !== void 0 ? openProp : openInternal : openInternal;
    // refs
    var inputIdInternal = useId('datepicker-input-');
    var datepickerIdInternal = useId('datepicker-');
    var inputId = id !== null && id !== void 0 ? id : inputIdInternal;
    var pickerId = datePickerId !== null && datePickerId !== void 0 ? datePickerId : datepickerIdInternal;
    var openRef = React.useRef(open);
    openRef.current = open;
    // callbacks
    var handleBlur = React.useCallback(function (e) {
        var _a, _b;
        if (!datepickerRef)
            return onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        var closestPicker = (_b = (_a = e === null || e === void 0 ? void 0 : e.relatedTarget) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, "#".concat(pickerId));
        if ((closestPicker === null || closestPicker === void 0 ? void 0 : closestPicker.getAttribute('id')) === datepickerRef.getAttribute('id')) {
            e.preventDefault();
            return onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }
        setOpenInternal(false);
        return onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [pickerId, datepickerRef, onBlur]);
    var handleFocus = React.useCallback(function (e) {
        if (variant === 'dropdown')
            return onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setOpenInternal(true);
        return onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, [onFocus, variant]);
    var handleSelectedChange = React.useCallback(function (newval) {
        // If this is a dropdown variant, we need to determine whether
        // we can close the floating UI calendar
        if (variant === 'dropdown') {
            if (closeDropdownOnSelectedChange && ((range && Array.isArray(newval) && newval.length > 1) || !range)) {
                setOpenInternal(false);
            }
        }
        return (onSelectedChange !== null && onSelectedChange !== void 0 ? onSelectedChange : setSelectedInternal)(newval);
    }, [closeDropdownOnSelectedChange, onSelectedChange, range, variant]);
    var handleGoToNextMonth = React.useCallback(function () {
        var _a;
        (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
        onGoToNextMonth === null || onGoToNextMonth === void 0 ? void 0 : onGoToNextMonth();
    }, [inputContainerRef, onGoToNextMonth]);
    var handleGoToPreviousMonth = React.useCallback(function () {
        var _a;
        (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
        onGoToPreviousMonth === null || onGoToPreviousMonth === void 0 ? void 0 : onGoToPreviousMonth();
    }, [inputContainerRef, onGoToPreviousMonth]);
    var handleCurrentDateChange = React.useCallback(function (newDateISO) {
        var _a;
        (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
        onCurrentDateChange === null || onCurrentDateChange === void 0 ? void 0 : onCurrentDateChange(newDateISO);
    }, [inputContainerRef, onCurrentDateChange]);
    var handleInputChange = React.useCallback(function (e) {
        function refocusInput() {
            setTimeout(function () {
                if (typeof document !== 'undefined') {
                    // need to manually query for the element because the
                    // inputContainerRef may have changed before this timeout is called
                    var input = document.querySelector("#".concat(inputId));
                    input === null || input === void 0 ? void 0 : input.focus();
                }
            }, 0);
        }
        var value = e.currentTarget.value;
        var _a = __read(range ? value.split(/\s*-\s*/) : [value], 2), date1 = _a[0], date2 = _a[1];
        var d1 = dayjs(date1, format, true);
        var d2 = dayjs(date2, format, true);
        if ((range && d1.isValid() && d2.isValid()) || (!range && d1.isValid())) {
            var iso1 = d1.toISOString();
            var iso2 = '';
            try {
                iso2 = d2.toISOString();
            }
            catch (error) {
                /* no-op for non-range values */
            }
            var onChangeVal = range ? [iso1, iso2] : iso1;
            onSelectedChange === null || onSelectedChange === void 0 ? void 0 : onSelectedChange(onChangeVal);
            setSelectedInternal(onChangeVal);
            setInternalInputVal('');
        }
        else {
            setInternalInputVal(value);
            onSelectedChange === null || onSelectedChange === void 0 ? void 0 : onSelectedChange(range ? [] : '');
            setSelectedInternal(undefined);
        }
        refocusInput();
    }, [format, inputId, onSelectedChange, range]);
    var handleInputClick = React.useCallback(function (e) {
        var _a;
        if (variant === 'input')
            return;
        var tgt = e.target;
        setOpenInternal(function (prev) { return !prev; });
        if ((tgt === null || tgt === void 0 ? void 0 : tgt.getAttribute('id')) !== inputId)
            (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
    }, [inputContainerRef, inputId, variant]);
    var handleClear = React.useCallback(function () {
        setInternalInputVal('');
        onSelectedChange === null || onSelectedChange === void 0 ? void 0 : onSelectedChange(range ? [] : '');
        setSelectedInternal(undefined);
    }, [onSelectedChange, range]);
    var handleKeyDown = React.useCallback(function (e) {
        if (e.key === 'Enter')
            return setOpenInternal(function (prev) { return !prev; });
        if (!datepickerRef)
            return;
        if (e.key === 'ArrowDown') {
            // Shift focus to be inside the datepicker
            return datepickerRef.focus();
        }
    }, [datepickerRef]);
    var handlePickerKeyDown = React.useCallback(function (e) {
        if (variant === 'dropdown' && e.key === 'Escape') {
            // close the picker and shift focus back to the "dropdown"
            setOpenInternal(false);
            if (typeof document !== 'undefined') {
                var input = document.getElementById(inputId);
                input === null || input === void 0 ? void 0 : input.focus();
            }
        }
    }, [inputId, variant]);
    // internal components
    var DateMaskInput = React.useCallback(function (_a) {
        var value = _a.value, rest = __rest(_a, ["value"]);
        // The same mask format can be used for either of the two supported formats
        var mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
        var pipe = createAutoCorrectedDatePipe(format.toLowerCase());
        if (range)
            mask = __spreadArray(__spreadArray(__spreadArray([], __read(mask), false), [' ', '-', ' '], false), __read(mask), false);
        return (_jsx(MaskedInput, __assign({}, rest, { value: value, ref: function (obj) {
                var el = (obj === null || obj === void 0 ? void 0 : obj.inputElement) || null;
                if (typeof ref === 'function')
                    ref(el);
                else if (ref)
                    ref.current = el;
            }, mask: mask, pipe: pipe, placeholderChar: "_", keepCharPositions: true })));
    }, [format, range, ref]);
    var DateTimeMaskInput = React.useCallback(function (_a) {
        var value = _a.value, rest = __rest(_a, ["value"]);
        var pipe = function (conformedValue) { return conformedValue.toUpperCase(); };
        var getMask = function () {
            var result = [/(0|1)/, /\d/, '/', /(0|1|2|3)/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' '];
            var BASE_HOUR_MINUTE_MASK_SEGMENTS = Object.freeze([/\d/, ':', /(0|1|2|3|4|5)/, /\d/]);
            var SECOND_MASK_SEGMENTS = Object.freeze([':', /(0|1|2|3|4|5)/, /\d/]);
            var PERIOD_MASK_SEGMENTS = Object.freeze([' ', /(A|P)/i, 'M']);
            result.push((timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.use12HourClock) ? /(0|1)/ : /(0|1|2)/);
            BASE_HOUR_MINUTE_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
            if (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.withSeconds)
                SECOND_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
            if (timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.use12HourClock)
                PERIOD_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
            return range ? __spreadArray(__spreadArray(__spreadArray([], __read(result), false), [' ', '-', ' '], false), __read(result), false) : result;
        };
        var mask = getMask();
        return (_jsx(MaskedInput, __assign({}, rest, { value: value, ref: function (obj) {
                var el = (obj === null || obj === void 0 ? void 0 : obj.inputElement) || null;
                if (typeof ref === 'function')
                    ref(el);
                else if (ref)
                    ref.current = el;
            }, mask: mask, pipe: pipe, placeholderChar: "_", keepCharPositions: true })));
    }, [range, ref, timePickerProps]);
    // memos
    var formattedInputVal = React.useMemo(function () {
        if (!selectedVal)
            return '';
        if (Array.isArray(selectedVal))
            return selectedVal.map(function (s) { return dayjs(s).format(format); }).join(' - ');
        return dayjs(selectedVal).format(format);
    }, [format, selectedVal]);
    var endAdornment = React.useMemo(function () {
        var clearableBtn = clearable && Boolean(selectedVal === null || selectedVal === void 0 ? void 0 : selectedVal.length) && (_jsx(Button, { "aria-label": translate('datepicker.input.clearBtnLabel'), icon: IconClose, onClick: handleClear, variant: "icon" }));
        if (variant === 'dropdown') {
            if (open) {
                return (_jsxs(_Fragment, { children: [clearableBtn, !hideEndAdornment && (_jsx(Button, { "aria-label": translate('datepicker.input.closePickerBtnLabel'), icon: IconChevronUp, variant: "icon" }))] }));
            }
            return (_jsxs(_Fragment, { children: [clearableBtn, !hideEndAdornment && (_jsx(Button, { "aria-label": translate('datepicker.input.openPickerBtnLabel'), icon: IconChevronDown, variant: "icon" }))] }));
        }
        return clearableBtn;
    }, [clearable, handleClear, hideEndAdornment, open, selectedVal === null || selectedVal === void 0 ? void 0 : selectedVal.length, translate, variant]);
    // effects
    React.useEffect(function () {
        // add click detection for inside the datepicker AND the input element
        if (typeof document !== 'undefined') {
            var clickHandler_1 = function (e) {
                var _a;
                var tgt = e.target;
                var closestInput = tgt.closest("#".concat(inputId));
                var closestDatepicker = tgt.closest("#".concat(pickerId));
                if ((inputContainerRef && (closestInput === null || closestInput === void 0 ? void 0 : closestInput.getAttribute('id')) === inputContainerRef.getAttribute('id')) ||
                    (datepickerRef && (closestDatepicker === null || closestDatepicker === void 0 ? void 0 : closestDatepicker.getAttribute('id')) === datepickerRef.getAttribute('id'))) {
                    // Refocus the input
                    return (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
                }
            };
            var keydownHandler_1 = function (e) {
                var _a;
                if (openRef.current && e.key === 'Escape') {
                    (_a = inputContainerRef === null || inputContainerRef === void 0 ? void 0 : inputContainerRef.querySelector('input')) === null || _a === void 0 ? void 0 : _a.blur();
                    setOpenInternal(false);
                }
            };
            document.addEventListener('click', clickHandler_1);
            document.addEventListener('touchstart', clickHandler_1);
            document.addEventListener('keydown', keydownHandler_1);
            return function () {
                document.removeEventListener('click', clickHandler_1);
                document.removeEventListener('touchstart', clickHandler_1);
                document.removeEventListener('keydown', keydownHandler_1);
            };
        }
    }, [pickerId, datepickerRef, inputId, inputContainerRef, variant]);
    // local render variables
    var startingDate = formattedInputVal
        ? dayjs(range ? formattedInputVal.split(/\s*-\s*/)[0] : formattedInputVal, format, true).toISOString()
        : undefined;
    return (_jsxs(_Fragment, { children: [_jsx(Input, __assign({ active: open, autoComplete: "off", classes: {
                    endAdornmentContainer: dropdownEndAdornmentClassName,
                    input: dropdownClassName,
                    startAdornmentContainer: dropdownStartAdornmentClassName,
                }, description: description, disabled: disabled, endAdornment: endAdornment, id: inputId, inputComponent: mask ? (pickerVariant === 'datetimepicker' ? DateTimeMaskInput : DateMaskInput) : undefined, inputProps: { ref: ref }, onBlur: handleBlur, onChange: handleInputChange, onClick: handleInputClick, onFocus: handleFocus, onKeyDown: handleKeyDown, placeholder: range ? "".concat(format, " - ").concat(format) : format.replace('A', '__'), readOnly: variant === 'dropdown', ref: setInputContainerRef, startAdornment: !hideStartAdornment ? _jsx(IconCalendar, {}) : null, value: internalInputVal || formattedInputVal, label: label }, inputProps)), inputContainerRef && (_jsx(FloatingUI, __assign({ anchor: inputContainerRef, elevated: true, open: open, placement: placement, styled: false }, floatingUiProps, { children: _jsx(DatePicker, __assign({ classes: restClasses, id: pickerId, onCurrentDateChange: handleCurrentDateChange, onGoToNextMonth: handleGoToNextMonth, onGoToPreviousMonth: handleGoToPreviousMonth, onKeyDown: handlePickerKeyDown, onSelectedChange: handleSelectedChange, pickerVariant: pickerVariant, range: range, ref: setDatepickerRef, startingDate: startingDate, selected: selectedVal, tabIndex: tabIndex, timePickerProps: timePickerProps, translate: translateProp }, rest)) })))] }));
});
DatePickerInputImpl.displayName = displayName;
export var DatePickerInput = React.forwardRef(function (props, ref) {
    var _a;
    return (_jsx(DatePickerInputImpl, __assign({}, props, { className: clsx((_a = props.classes) === null || _a === void 0 ? void 0 : _a.root, props.className, 'Hawkins-DatePickerInput'), ref: ref, variant: "input" })));
});
DatePickerInput.displayName = 'DatePickerInput';
/**
 * What is this, you may ask? Well, for testing the DatePickerDropdown components,
 * the Hawkins Audit will fail when it cannot find certain TestIDs or CSS classes.
 * This is due to the way the component returns a <React.Fragment /> as its root element,
 * instead of a <div />. As such, this component only exists to force the inner elements
 * to be rendered to the DOM for testing, and is not exported for consumption by
 * @hawkins/components consumers
 *
 * @internal
 */
export var DatePickerInputForAuditTesting = React.forwardRef(function (props, ref) { return (_jsx(DatePickerInput, __assign({}, props, { open: true, ref: ref }))); });
DatePickerInputForAuditTesting.displayName = 'DatePickerInput';
